import React from 'react';
import MyMap from './MapContainer';

export default class MapRender extends React.Component {
    constructor(props) {
        super(props);
        this.state=({
            currentLocation : this.props.currentLocation,
            isReset:false
        });
    }

    compareObj=(obj1, obj2)=>{
        if (obj1 === obj2) {
          return true;
        }
      
        if (typeof obj1 !== 'object' || obj1 === null || 
            typeof obj2 !== 'object' || obj2 === null) {
          return false;
        }
      
        const keys1 = Object.keys(obj1);
        const keys2 = Object.keys(obj2);
      
        if (keys1.length !== keys2.length) {
          return false;
        }
      
        for (let key of keys1) {
          if (!keys2.includes(key) || !this.compareObj(obj1[key], obj2[key])) {
            return false;
          }
        }
      
        return true;
    }
    componentWillReceiveProps(newProps){
        // if(this.props.currentLocation !== newProps.currentLocation){
        // console.log(`is matched: ${this.compareObj(this.props.currentLocation, newProps.currentLocation)}`)
        if(!this.compareObj(this.props.currentLocation, newProps.currentLocation)){
            this.setState({
                currentLocation: newProps.currentLocation,
                isReset:true
            });
            // console.log("currentLocation= ", this.state.currentLocation)

            this.resetRev();
        }
    }
    resetRev = () => {
        setTimeout(() => {
            this.setState({
                isReset:false
            });
        }, 800);
    }
    //SEC: AIzaSyDOsfTA_2CBvCcOxQwpLYrlm1UBbBiLgx0
    //Test: AIzaSyA1y8bMI9HUR3lZvjAf6doh4vcEaVz6hGM
    render() {
        // let defaultText = this.props.language && this.props.language==='ar'?'الرجاء تحديد الموقع':'Please select location';
        let defaultText = 'Lat: ' + this.state.currentLocation.lat + ', Lng: ' + this.state.currentLocation.lng;
        // pos=this.props.curlocation;
        // console.log(this.props.currentLocation);
        return(
            <React.Fragment>
                {this.state.isReset?(
                    <div style={{display:'block',margin:'auto'}}>Loading..</div>
                ):(
                    <MyMap
                        currentLocation={this.state.currentLocation}
                        defaultText={defaultText}
                        action={this.props.action}
                        language={this.props.language}
                        defaultZoom={this.state.currentLocation.lat===24.176869443745133? 5 : 14}
                    />
                )}
            </React.Fragment>
        )
    }
}